import React from "react";
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  Button,
  Stack,
  Avatar,
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faPhone,
  faDownload,
  faLocationDot,
} from "@fortawesome/free-solid-svg-icons";
import { faGithub, faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { CONTACT, PROFILE, openWhatsApp } from "../../utils/constants";

const Contact = () => {
  return (
    <Box id="contact" sx={{ py: 8 }}>
      <Typography
        variant="h2"
        sx={{
          mb: 1,
          background: "linear-gradient(135deg, #2563eb, #7c3aed)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
        }}
      >
        Contact
      </Typography>

      <Typography color="text.secondary" sx={{ maxWidth: 760, mb: 4 }}>
        {PROFILE.availability}
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12} md={4}>
          <Card sx={{ height: "100%", borderRadius: 4 }}>
            <CardContent sx={{ p: 3 }}>
              <Avatar
                src={CONTACT.profileImage}
                alt={CONTACT.fullName}
                imgProps={{ loading: "lazy", referrerPolicy: "no-referrer" }}
                sx={{
                  width: 130,
                  height: 130,
                  mb: 2,
                  mx: "auto",
                  border: "3px solid",
                  borderColor: "primary.main",
                  boxShadow: "0 8px 20px rgba(0,0,0,0.12)",
                }}
              />
              <Typography
                variant="h5"
                sx={{ fontWeight: 700, mb: 2, textAlign: "center" }}
              >
                Let’s work together
              </Typography>
              <Typography
                color="text.secondary"
                sx={{ lineHeight: 1.8, mb: 3, textAlign: "center" }}
              >
                I’m open to software roles, frontend roles, technical support
                roles, and selected freelance opportunities. The fastest way to
                reach me is WhatsApp.
              </Typography>

              <Stack spacing={1.5}>
                <Button
                  variant="contained"
                  onClick={openWhatsApp}
                  startIcon={<FontAwesomeIcon icon={faWhatsapp} />}
                >
                  Chat on WhatsApp
                </Button>

                <Button
                  variant="outlined"
                  component="a"
                  href={CONTACT.cvFile}
                  target="_blank"
                  rel="noopener noreferrer"
                  startIcon={<FontAwesomeIcon icon={faDownload} />}
                >
                  Download CV
                </Button>

                <Button
                  variant="text"
                  component="a"
                  href={CONTACT.github}
                  target="_blank"
                  rel="noopener noreferrer"
                  startIcon={<FontAwesomeIcon icon={faGithub} />}
                >
                  View GitHub
                </Button>
              </Stack>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={8}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <Card sx={{ borderRadius: 4, height: "100%" }}>
                <CardContent sx={{ p: 3 }}>
                  <Typography sx={{ mb: 1.5, color: "primary.main" }}>
                    <FontAwesomeIcon icon={faPhone} />
                  </Typography>
                  <Typography variant="h6" sx={{ fontWeight: 700, mb: 0.5 }}>
                    Phone
                  </Typography>
                  <Typography color="text.secondary" sx={{ mb: 2 }}>
                    {CONTACT.phoneDisplay}
                  </Typography>
                  <Button
                    component="a"
                    href={`tel:${CONTACT.phoneIntl}`}
                    variant="outlined"
                  >
                    Call Now
                  </Button>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Card sx={{ borderRadius: 4, height: "100%" }}>
                <CardContent sx={{ p: 3 }}>
                  <Typography sx={{ mb: 1.5, color: "primary.main" }}>
                    <FontAwesomeIcon icon={faEnvelope} />
                  </Typography>
                  <Typography variant="h6" sx={{ fontWeight: 700, mb: 0.5 }}>
                    Primary Email
                  </Typography>
                  <Typography
                    color="text.secondary"
                    sx={{ mb: 2, wordBreak: "break-word" }}
                  >
                    {CONTACT.emails[0]}
                  </Typography>
                  <Button
                    component="a"
                    href={`mailto:${CONTACT.emails[0]}`}
                    variant="outlined"
                  >
                    Send Email
                  </Button>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Card sx={{ borderRadius: 4, height: "100%" }}>
                <CardContent sx={{ p: 3 }}>
                  <Typography sx={{ mb: 1.5, color: "primary.main" }}>
                    <FontAwesomeIcon icon={faEnvelope} />
                  </Typography>
                  <Typography variant="h6" sx={{ fontWeight: 700, mb: 0.5 }}>
                    Secondary Email
                  </Typography>
                  <Typography
                    color="text.secondary"
                    sx={{ mb: 2, wordBreak: "break-word" }}
                  >
                    {CONTACT.emails[1]}
                  </Typography>
                  <Button
                    component="a"
                    href={`mailto:${CONTACT.emails[1]}`}
                    variant="outlined"
                  >
                    Send Email
                  </Button>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Card sx={{ borderRadius: 4, height: "100%" }}>
                <CardContent sx={{ p: 3 }}>
                  <Typography sx={{ mb: 1.5, color: "primary.main" }}>
                    <FontAwesomeIcon icon={faLocationDot} />
                  </Typography>
                  <Typography variant="h6" sx={{ fontWeight: 700, mb: 0.5 }}>
                    Location
                  </Typography>
                  <Typography color="text.secondary" sx={{ mb: 2 }}>
                    {CONTACT.location}
                  </Typography>
                  <Button onClick={openWhatsApp} variant="outlined">
                    Start Conversation
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Contact;
